import React, { useEffect, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';

import { LoadingLayout } from 'common/components/layout';
import ModalListener from 'common/components/modal/ModalListener';
import { getTenantId } from 'common/helpers/apiHelper';
import { timeFormat, getClientTimezone } from 'common/helpers/dateHelper';
import { getRouterType } from 'common/helpers/routerHelper';
import {
  isShutDown,
  getShutdownWindow
} from 'common/helpers/sharedFeatureFlags';
import { getCustomer } from 'redux/customer/actions';
import { getResourceBundle } from 'redux/localization/actions';
import { useLocalization } from 'redux/localization/utils/hooks';
import { getForWeb } from 'redux/settings/actions';
import useAnalytics from 'utils/hooks/useAnalytics';
import Widgets from 'widgets/Widgets';

import BrowserRoutes from './BrowserRoutes';
import HashRoutes from './HashRoutes';
import InvalidGateway from './InvalidGateway';
import {
  createVisitorId,
  getVisitorId,
  getDeviceType
} from './common/helpers/internalAnalytics';

const Routes = () => {
  const [isInvalidGateway, setIsInvalidGateway] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(!getVisitorId());

  const { t } = useLocalization();
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting.data);
  const resourceBundle = useSelector((state) => state.localization.data);

  const recordDeviceType = () => isFirstLoad || false;
  useAnalytics(recordDeviceType, 'Visitor Device', getDeviceType());
  useEffect(() => {
    if (!getVisitorId()) {
      createVisitorId();
      setIsFirstLoad(true);
    } else {
      setIsFirstLoad(false);
    }
  }, []);

  useEffect(() => {
    const onError = () => {
      setIsInvalidGateway(true);
    };
    if (!setting) {
      dispatch(getForWeb(onError));
    }
  }, [dispatch, setting]);

  useEffect(() => {
    if (!resourceBundle) {
      dispatch(getResourceBundle());
    }
  }, [dispatch, resourceBundle]);

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  if (isShutDown(getTenantId())) {
    const { endTime } = getShutdownWindow();
    const timeZone = getClientTimezone();
    return (
      <p style={{ textAlign: 'center', margin: '0 auto' }}>
        {t('general.errorMessages.systemMaintenance', {
          endTime: timeFormat(t, endTime, timeZone),
          timeZone
        })}{' '}
      </p>
    );
  }

  if (isInvalidGateway) {
    return <InvalidGateway />;
  }

  if (!setting || !resourceBundle) {
    return <LoadingLayout />;
  }

  /* TODO handle checkout for 404 error */

  const routerType = getRouterType();

  let AppRoutes = BrowserRoutes;
  if (routerType === 'Hash') {
    AppRoutes = HashRoutes;
  }

  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey="6LfaKNkgAAAAAK8eObCn0Gu5gRtJjmwNNhUhAqKV"
        language="en"
        useRecaptchaNet="false"
        useEnterprise="true"
        scriptProps={{
          async: false, // optional, default to false,
          defer: false, // optional, default to false
          appendTo: 'head', // optional, default to "head", can be "head" or "body",
          nonce: undefined // optional, default undefined
        }}
      >
        <Widgets />
        <AppRoutes />
        <ModalListener />
      </GoogleReCaptchaProvider>
    </>
  );
};

export default Routes;
